import { Group } from "@/entities/group/group";
import { Metadata } from "@/entities/metadata/metadata";
import axios from "axios"
import { IGroupRepository } from "./group.types";

export class GroupAPIRepository implements IGroupRepository {
    async getGroup(groupID: string): Promise<Group> {
        const response = await axios.get(`https://villa.kitchen/api/group/read/${groupID}`)
        if (response.status == 200) {
            console.log(response.data)
            return new Group(response.data)
        } else {
            return new Group({
                groupId: -1,
                groupName: "",
                enabled: false,
                metadata: new Metadata({ show: false }),
                subGroupList: [],
                parentGroupList: [],
                productList: [],
            }
            );
        }
    }
    async getGroupRecursion(groupID: string, bypassCache = false): Promise<Group> {
        let g: Group
        if (bypassCache) {
            g = await this.getGroup(groupID);
        } else {
            g = await this.getGroupWithCache(groupID);
        }
        if (g.metadata.description != null) {
            if (g.metadata.description == "2 For") {
                const twoFor = await this.getTwoFor(g.groupId.toString());
                g.productList.forEach((product) => {
                    product["twofor"] = twoFor["two4Dict"][product["cprcode"].toString()];
                });
            }
        }
        const subGroup = g.subGroupList;
        const subGroupDate = await Promise.all(subGroup
            .map((id) => this.getGroupRecursion(id.toString(), bypassCache)));

        // subGroupDate.where((g) => g.groupId >= 0).forEach((group) => {
        //     g.subGroup[group.groupId] = group;
        //     g.productList.addAll(group.productList);
        // });

        return g
    }

    async getTwoFor(groupID: string): Promise<any> {
        const response = await axios.get(`https://villa.kitchen/api/promotion/get-two4?groupId=${groupID}`);
        if (response.status == 200) {
            return response.data;
        } else {
            throw new Error('Failed to load two for $groupId');
        }
    }
    async getGroupWithCache(groupID: string): Promise<Group> {
        return new Group({
            groupId: -1,
            groupName: "",
            enabled: false,
            metadata: new Metadata({ show: false }),
            subGroupList: [],
            parentGroupList: [],
            productList: [],
        }
        );
        // const file = await DefaultCacheManager().getSingleFile('$domain/api/group/read/${groupId}');
        // if (await file.exists()) {
        //     const str = await file.readAsString();
        //     return new Group((str));
        // }
        // throw new Error('Failed to load group $groupId');
    }
}
